import React from 'react';
import Button from './../../Common/Button/Button';
import CommunityImg from '../../../../../sustainability/src/components/Sustainability/CommunityImg/CommunityImg';
import PartnerImg from '../../../images/pages_partner_creative.svg';
import PartnerLogo from '../../../images/Partners_logo.svg';
import rightArrow from './../../../images/Arrow-Right.svg';
import './Creative.scss';

const Creative = () => {

  const openLink = () => window.open(`http://app.impact.com/campaign-campaign-info-v2/noissue.brand?io=C1K0Z1laaNiFTZZOt0ctvqRdOGiA77l6logQY92YfUs3u%2FRx3rUiU3nO%2FS6ryTQf`, '_blank', 'noopener');

  return (
    <div className="creative-wrapper">
      <div className="left-section">
        <CommunityImg src={PartnerImg} />
      </div>
      <div className="right-section">
        <CommunityImg className="partner-logo-img" src={PartnerLogo} />
        <h2 className="heading">
          Creative Partners
        </h2>
        <div className="sub-heading">
          Are you a graphic designer or creative agency who develops branding for businesses? Make noissue your recommended sustainable packaging solution for clients, and earn commissions off every order. Apply and get started today!
        </div>
        <div className="button-container">
          <Button bgColor="#FD566F" label="Apply Now" imgSrc={rightArrow} onClick={openLink} />
        </div>
      </div>
    </div>
  )
}

export default Creative;